module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (18).cc744d46.jpg";